'use client';

import tokens from '../tokens/global.json.mjs';
var getColors = function getColors(brand) {
  var grade = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "primary";
  var tokens = getTokens(brand, grade);
  var colorTokens = {};
  Object.keys(tokens).forEach(function (key) {
    var colorToken = tokens[key].value;
    colorTokens[key] = colorToken;
  });
  return colorTokens;
};
var getTokens = function getTokens(brand, grade) {
  if (grade === "primary") {
    switch (brand) {
      case "gray":
        return tokens.color.neutrals.gray;
      case "orange":
        return tokens.color.neutrals.orange;
      case "blue":
        return tokens.color.neutrals.blue;
      case "purple":
        return tokens.color.neutrals.purple;
      case "yellow":
        return tokens.color.neutrals.yellow;
      case "sambla":
        return tokens.color.sambla.green.shade;
      case "advisa":
        return tokens.color.advisa.teal.shade;
      case "omalaina":
        return tokens.color.omalaina.orange.shade;
      case "rahalaitos":
        return tokens.color.rahalaitos.green.shade;
      case "digifinans":
        return tokens.color.digifinans.blue.shade;
      case "rahoitu":
        return tokens.color.rahoitu.orange.shade;
      case "samblagroup":
        return tokens.color.samblagroup.pink.shade;
      default:
        throw new Error("Unsupported brand: ".concat(brand));
    }
  } else if (grade === "secondary") {
    switch (brand) {
      case "sambla":
        return tokens.color.sambla.red.shade;
      case "advisa":
        return tokens.color.advisa.teal.shade;
      case "omalaina":
        return tokens.color.omalaina.orange.shade;
      case "rahalaitos":
        return tokens.color.rahalaitos.green.shade;
      case "digifinans":
        return tokens.color.digifinans.blue.shade;
      case "rahoitu":
        return tokens.color.rahoitu.orange.shade;
      case "samblagroup":
        return tokens.color.samblagroup.pink.shade;
      default:
        throw new Error("Unsupported brand: ".concat(brand));
    }
  } else {
    throw new Error("Unsupported grade: ".concat(grade));
  }
};
var grayColors = getColors("gray");
var blueColors = getColors("blue");
var orangeColors = getColors("orange");
var purpleColors = getColors("purple");
var yellowColors = getColors("yellow");
getColors("sambla");
getColors("sambla", "secondary");
getColors("advisa");
getColors("omalaina");
getColors("rahalaitos");
getColors("digifinans");
getColors("rahoitu");
getColors("samblagroup");
export { blueColors, grayColors, orangeColors, purpleColors, yellowColors };